import { useMobileMenuContext } from "@/components/layouts/MobileMenuProvider.tsx";
import { type BackgroundColorValue, Button, Div, Flex, Text, useColorSchemeValue } from "@hopper-ui/components";
import { DismissIcon } from "@hopper-ui/icons";
import { useSharedTranslation } from "@workleap-ai/shared";
import { useTranslation } from "react-i18next";

export const NavbarMobileOverlay = () => {
    const { t } = useTranslation();
    const { tShared } = useSharedTranslation();
    const { toggleMobileMenu } = useMobileMenuContext();

    const backgroundColor = useColorSchemeValue(
        "core_samoyed",
        "core_rock-900"
    ) as BackgroundColorValue;

    return (
        <Div
            alignItems="center"
            justifyContent="space-between"
            paddingX="inset-md"
            position="absolute"
            top="0"
            left="0"
            width="100%"
            UNSAFE_minHeight="4.4375rem"
            backgroundColor={backgroundColor}
            zIndex={30}
            display={{ base: "flex", sm: "none" }}
        >
            <Flex
                className="wai-reveal-left-to-right"
                alignItems="center"
                gap="inline-md"
            >
                <img src="/favicon.svg" alt={tShared("workleapAi")} />
                <Text
                    fontWeight="core_410"
                    color="neutral"
                    UNSAFE_fontSize="1.25rem"
                    UNSAFE_fontFamily="var(--hop-font-family-primary)"
                    letterSpacing="-0.05rem"
                    UNSAFE_lineHeight="1.2"
                >
                    {tShared("workleapAi")}
                </Text>
            </Flex>
            <Button
                color="neutral-weak"
                aria-label={t("closeMenu")}
                variant="ghost-secondary"
                onPress={toggleMobileMenu}
            >
                <DismissIcon />
            </Button>
        </Div>
    );
};
